export const MILESTONE_ROADMAP_STATUS = {
  COMPLETED: 'completed',
  CURRENT: 'current',
  UPCOMING: 'upcoming',
};

export const ROADMAP_EYEBROW_CURRENT = 'Currently in';
export const ROADMAP_LIST_EYEBROW = 'Milestone roadmap';
export const ROADMAP_UP_NEXT_LABEL = 'Up next';
export const ROADMAP_HERE_TEXT = '← here';
export const ROADMAP_EMPTY_DATE = '—';
export const ROADMAP_NO_DATA_TEXT = 'No milestone data available';
export const ROADMAP_IN_PROGRESS_TEXT = 'In progress';
export const ROADMAP_NOT_STARTED_TEXT = 'Not started yet';

export const ROADMAP_CURRENT_ROW_SCROLL_ID = 'current-milestone';
export const ROADMAP_SKELETON_KEYS = [
  'skeleton-1',
  'skeleton-2',
  'skeleton-3',
  'skeleton-4',
  'skeleton-5',
];
